import Darf from "../../../../models/darf";
import { IconFreeRights, IconHelp } from "@tabler/icons-react";
import FelixCard from "../../../util/ui/felixCard";
import {
  Box,
  CardContent,
  CardHeader,
  LinearProgress,
  Skeleton,
  Tooltip,
  Typography,
} from "@mui/material";
import MoedaText from "../../../util/ui/inputs/moedaText";
import { radius } from "../../../../theme";

type Props = {
  darf?: Darf;
};
export default function Isencao({ darf }: Props) {
  return (
    <FelixCard>
      <CardHeader
        title={"Isenção"}
        avatar={<IconFreeRights size={16} />}
        action={
          <Box display="flex" flexDirection="row" alignItems="center">
            <Tooltip title="Este é o valor vendido no mês que conta para a isenção. Até R$20 mil, o lucro dessas vendas é isento.">
              <Box sx={{ color: "text.secondary" }}>
                <IconHelp size={16} />
              </Box>
            </Tooltip>
          </Box>
        }
      />
      <CardContent>
        <Box display="flex" flexDirection="column" alignItems="center">
          <Typography
            variant="dataMono"
            color={
              darf && darf.operacoesComuns.valorVendidoIsentavel > 20000
                ? "error.main"
                : "text.primary"
            }
            sx={{
              fontWeight: 600,
              fontSize: 28,
              letterSpacing: "-0.02em",
              paddingBottom: 2,
            }}
          >
            {darf ? (
              <MoedaText value={darf.operacoesComuns.valorVendidoIsentavel} />
            ) : (
              <Skeleton variant="text" width={40} animation={false} />
            )}
          </Typography>
        </Box>
        <Box display="flex" alignItems="flex-end">
          {darf ? (
            <ProgressoIsencao
              valorVendido={darf.operacoesComuns.valorVendidoIsentavel}
            />
          ) : (
            <></>
          )}
        </Box>
      </CardContent>
    </FelixCard>
  );
}

interface ProgressoIsencaoProps {
  valorVendido: number;
}

function ProgressoIsencao({ valorVendido }: ProgressoIsencaoProps) {
  const limite = 20000;
  let value = 0;
  let posicaoIsencao = 0;
  let color: "success" | "error" = "success";
  if (valorVendido >= limite) {
    color = "error";
    value = 80;
    posicaoIsencao = (limite * 80) / valorVendido;
  } else {
    color = "success";
    value = (valorVendido * 80) / limite;
    posicaoIsencao = 80;
  }

  return (
    <Box width="100%" sx={{ position: "relative" }}>
      <LinearProgress
        sx={{
          height: 12,
          // radius-pill: a barra é pill, como botão e chip.
          borderRadius: `${radius.pill}px`,
          mb: 4,
        }}
        variant="determinate"
        color={color}
        value={value}
      />
      {/* Marca do limite de isenção: traço de tinta, não bloco colorido. */}
      <Box
        position="absolute"
        top={-4}
        left={`${posicaoIsencao}%`}
        bgcolor="text.primary"
        height={20}
        width={2}
        borderRadius={`${radius.pill}px`}
      ></Box>
      <Typography
        variant="dataMono"
        color="text.secondary"
        position="absolute"
        top={20}
        left={`${posicaoIsencao}%`}
        sx={{
          fontSize: 11,
          whiteSpace: "nowrap",
          transform: "translateX(-50%)",
        }}
      >
        <MoedaText value={limite} />
      </Typography>
    </Box>
  );
}
